module.exports = __webpack_public_path__ + "img/3.6688b051.jpg";